import { useMessage } from "../../../hooks/useMessage";
import { DELETE, RESERVATION_DELETE } from "../../../services";

export const useDelete = () => {
  const { openMessage } = useMessage();

  const onDelete = async (reserveId: string): Promise<boolean> => {
    try {
      const res = await DELETE(RESERVATION_DELETE(reserveId));
      openMessage("success", res.message);
      return true;
    } catch (error: any) {
      console.log(error);
      openMessage("error", error.error);
      return false;
    }
  };

  return {
    onDelete,
  };
};
